import {
  MRT_ColumnDef,
  MRT_Row,
  MaterialReactTable,
  useMaterialReactTable,
} from "material-react-table"
import { useAppSelector } from "../../../redux/hooks"
import { Box, Button } from "@mui/material"
import { defaultTableProps } from "../ResourceBudgetTable/constants"
import SortIcon from "@mui/icons-material/Sort"
import FileDownloadIcon from "@mui/icons-material/FileDownload"
import { useDispatch } from "react-redux"
import { useSelector } from "react-redux"
import { useEffect } from "react"
import { setProviderSummaryRows } from "../../../redux/slices/huddleSlice"
import { assignTableId } from "../../../../helper/utils"

type tableProps = {
  columns: MRT_ColumnDef<any>[]
  data: {}[]
  enableEditing?: boolean
  blurHandler?: any
  flex?: any
  setRows?: any
}

export const ProviderSummaryTable = (props: tableProps) => {
  const dispatch = useDispatch()

  const { columns, data, enableEditing, blurHandler, flex, setRows } = props
  const loading = useAppSelector((state) => state.app.loading)

  const maevaSelectedPracticesNoAll = useSelector((state: any) => {
    return state.metric.maevaSelectedPracticesNoAll
  })

  const table = useMaterialReactTable({
    ...defaultTableProps,
    columns: columns,
    data: data,
    editDisplayMode: "cell",
    enableSorting: true,
    enableMultiSort: false,
    enableEditing: true,
    muiEditTextFieldProps: ({ cell, row }) => {
      return {
        onBlur: (e) => {
          const previous = cell.getValue<number>()
          const current = parseFloat(e.target.value)
          if (previous !== current) {
            blurHandler(current, row)
          }
        },
        autoFocus: true,
      }
    },
    // enableTopToolbar={true}
    // enableToolbarInternalActions={false}
    muiTableHeadCellProps: {
      align: "center",
      sx: {
        backgroundColor: "#1A428A",
        color: "#fff",
        fontWeight: "bold",
        height: "32px",
        boxShadow: " #00000022 1.95px  0px 2.6px",
        border: "1px solid #E4E4E4",
        // padding: "0 !important",
        // border: "1px solid red"
      },
    },
    muiTableHeadRowProps: {},
    muiTableContainerProps: {
      sx: {
        borderRadius: "none",
        // top: 0,
        // left: 0,
        // right: 0,
        // bottom: 0,
        // position: "absolute",
        height: "fit-content",
        maxWidth: "93vw",
        maxHeight: "70vh",
      },
    },
    icons: {
      ArrowDownwardIcon: () => (
        <SortIcon sx={{ color: "#fff", ml: "7px", marginLeft: "10px" }} />
      ),
    },
    muiTableBodyCellProps: ({ cell, table }) => {
      return {
        align: "center",
        onClick: () => table.setEditingCell(cell),
        sx: {
          height: "48px",
          boxShadow: "#00000022 1.95px 0px 2.6px",
          color: "black",
          border: "1px solid #E4E4E4",
        },
      }
    },
    state: {
      isLoading: loading,
      columnVisibility: { Actions: false },
      columnPinning: {
        left: ["provider_name"],
        // left: ["provider_name", "yesterday.y_hourly_goal", "yesterday.y_hours", "yesterday.y_daily_prod_goal", "yesterday.y_actual_produced"],
      },
    },
  })

  useEffect(() => {
    dispatch(setProviderSummaryRows(table?.getPrePaginationRowModel().rows))
  }, [maevaSelectedPracticesNoAll])

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        // flexGrow: 1,
        // position: "relative",
        // border: "1px solid red"
        height: "fit-content",
        width: "fit-content",
      }}
    >
      <MaterialReactTable table={table} />
    </Box>
  )
}
